import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@ngneat/transloco';

@Pipe({
  name: 'residencyTypeOfIdentification',
})
export class ResidencyTypeOfIdentificationPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    let returnedText;
    switch (value) {
      case 'D': {
        returnedText = translate('TPA.ResidencyIdentificationType.VAT');
        break;
      }
      case 'R': {
        returnedText = translate('TPA.ResidencyIdentificationType.BirthNumber');
        break;
      }
      case 'S': {
        returnedText = translate('TPA.ResidencyIdentificationType.SocialSecurityNumber');
        break;
      }
      case 'J': {
        returnedText = translate('TPA.ResidencyIdentificationType.Other');
        break;
      }
      default: {
        returnedText = '';
      }
    }
    return returnedText;
  }
}
